import {useEffect, useState} from "react";
import {useInView} from "react-intersection-observer";
import styles from "components/media/image.module.scss";
import Image from "next/image";


export default function ImageViewer(props) {
    const {item, isActive} = props;
    const height = props.height || `100%`;
    const [initialized, setInitialized] = useState(false);
    const onContentView = props.onContentView || function (id) {};

    const [ nearRef, nearInView, nearEntry ] = useInView({
        threshold: 0,
        triggerOnce: false,
        rootMargin: '50% 0px 50% 0px',
        // rootMargin: '0px 0px 0px 0px',
        fallbackInView: true,
    });

    const [ref, inView, entry] = useInView({
        threshold: 0,
        triggerOnce: false,
        rootMargin: '-49% 0px -49% 0px',
        // rootMargin: '0px 0px 0px 0px',
        fallbackInView: true,
    });

    useEffect(() => {
        if (!initialized && nearInView) {
            setInitialized(true);
        }
    }, [nearInView]);

    useEffect(() => {
        if (inView && isActive) {
            onContentView(item);
        }
    }, [inView, isActive]);

    return (
        <>
            <div className={styles.wrapper} style={{paddingBottom: height}} ref={nearRef}>
                <div className={styles.item} ref={ref}>
                {
                    initialized
                        ?
                            <Image onDrag={e => e.preventDefault()} unoptimized src={item.url} layout="fill" objectFit="cover" objectPosition="center"/>
                        :
                            <div />
                }
                </div>
            </div>
        </>
    )
}